import React, { useMemo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { CustomTable } from "@components/custom-table/table";
import { resetDelete } from "@helpers/custom-delete/controller/delete-slice";
import { url } from "@constants/url-constants";

import { S3_BASE_URL } from "@constants/constants";
import { getMediumType } from "../../../helpers/helpers";
import DeleteModal from "@components/custom-table/DeleteModal";
import { resetError, resetState, resetSuccess } from "../../banner/controller/banner-slice";
import { getPaymentList } from "../services/payment-service";
export const Purchase = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const payments = useSelector((state) => state.payment.payments);
  const pagination = useSelector((state) => state.payment.pagination);
  const isLoading = useSelector((state) => state.payment.loading);
  const responseMessage = useSelector((state) => state.payment.responseMessage);
  const successMessage = useSelector((state) => state.payment.successMessage);
  const deleteMessage = useSelector((state) => state.delete.successMessage);
  const currentPage = pagination?.current_page;
  const deleteUrl = url.banners;
  const [deleteModel, setDeleteModel] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  useEffect(() => {
    if (responseMessage !== null) {
      dispatch(resetState());
    }
  }, [dispatch, responseMessage]);

  useEffect(() => {
    if (deleteMessage !== null) {
      toast.success(deleteMessage);

      dispatch(resetDelete());
    }
  }, [dispatch, deleteMessage]);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success(successMessage);

      dispatch(resetSuccess());
    }
  }, [dispatch, successMessage]);

  const handleCreateBanner = () => {
    navigate(`/banner/add`);
    dispatch(resetError());
  };
  const handleDeleteBanner = ({ id, url, deleted_at }) => {
    setDeleteModel(true);
    setDeleteData({ id, url, deleted_at });
  };

  const handleEditState = ({ id, page }) => {
    navigate(`/banner/edit/${id}?current_page=${page}`);
    dispatch(resetError());
  };

  // const columns = useMemo(
  //   () => [
  //     {
  //       header: "Name",
  //       accessorKey: "user.full_name",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //     },
  //     {
  //       header: "Mobile",
  //       accessorKey: "user.mobile",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //     },
  //     {
  //       header: "Plans",
  //       accessorKey: "",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: (cellProps) => {
  //         return cellProps.row.original.media_id
  //           ? getMediumType(cellProps.row.original.media?.type) +
  //           "-" +
  //           cellProps.row.original.media?.title //TODO
  //           : "Posts-" + cellProps.row.original.post.title;
  //       },
  //     },

  //   ],
  //   [currentPage, deleteUrl]
  // );
  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          return cellProps.row.original?.user?.full_name ? (
            cellProps.row.original?.user?.full_name
          ) : null;
        },
      },
      {
        header: "Mobile",
        accessorKey: "type",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          return cellProps.row.original?.user?.mobile ? (
            cellProps.row.original?.user?.mobile
          ) : null;
        },
      },
      {
        header: "Membership Plan",
        accessorKey: "row",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          let membershipPlanDetails = cellProps.row.original?.membership_plan?.name ?? "-";
          return membershipPlanDetails;
        },
      },
      {
        header: "Lifetime Plan",
        accessorKey: "media_details",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          let mediaDetails = cellProps.row.original?.media_details ?? [];
          if (mediaDetails.length === 0) {
            return "-";
          }
          return mediaDetails.map((m, index) => (
            <React.Fragment key={m.id}>
              {m.title}
              {index < mediaDetails.length - 1 && ', '}
            </React.Fragment>
          ));
        },
      },
      {
        header: "Start Date",
        accessorKey: "created_at",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          const createdAt = new Date(cellProps.row.original?.created_at);
          return createdAt ? createdAt.toLocaleDateString() : null;
        },
      },
      {
        header: "End Date",
        accessorKey: "",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          const endAt = new Date(cellProps.row.original?.user?.subscription_end_date);
          return endAt ? endAt.toLocaleDateString() : null;
        },
      },
      {
        header: "Amount",
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          const amount = new Date(cellProps.row.original?.amount);
          return amount ? amount / 100 : null;
        },
      }

    ],
    [currentPage, deleteUrl]
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModel}
        onDeleteClick={handleDeleteBanner}
        onCloseClick={() => setDeleteModel(false)}
        data={deleteData}
      />
      <div className="page-content">
        <ToastContainer autoClose={2000} />
        <div className="container-fluid">
          {
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="">
                    <div className="d-flex align-items-center text-start">
                      <h5 className="mb-0 card-title flex-grow-1">
                        Purchase List
                      </h5>
                    </div>
                  </CardBody>
                  <CardBody>
                    <CustomTable
                      loading={isLoading}
                      columns={columns}
                      data={payments || []}
                      isCustomPageSize={true}
                      isGlobalFilter={true}
                      isJobListGlobalFilter={true}
                      isPagination={true}
                      isAddButton={true}
                      page={currentPage}
                      isEpisode={false}
                      paginationCount={pagination?.total_count}
                      handleUserClick={handleCreateBanner}
                      handleList={getPaymentList}
                      paginationLimit={pagination}
                      buttonClass="btn btn-success"
                      buttonName="Add"
                      theadClass="thead-light"
                      SearchPlaceholder="Search for ..."
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }
        </div>
      </div>
    </React.Fragment>
  );
};
